// import { useState, useEffect } from 'react';

// export default function Hero() {
//   const [currentSlide, setCurrentSlide] = useState(0);

//   const slides = [
//     {
//       image: "/assets/Hero1.jpg",
//       title: "Trusted Cardiovascular Solutions for Healthier Hearts",
//       description: "Pioneering excellence in cardiac and diabetic health care with innovative pharmaceutical solutions. Committed to improving cardiovascular, diabetic health along with acute and chronic disease through quality medicines and dedicated service."
//     },
//     {
//       image: "/assets/Hero2.jpg",
//       title: "Comprehensive Diabetic Care Solutions",
//       description: "Providing premium quality diabetic care medicines and cardiovascular products. Dedicated to sourcing the finest pharmaceutical solutions for better health outcomes and improved quality of life."
//     },
//     {
//       image: "/assets/Hero3.jpg",
//       title: "Quality Medicines for Better Health",
//       description: "Sourcing and distributing premium pharmaceutical products for cardiac, diabetic, and chronic disease management. Your trusted partner in healthcare excellence with ISO 9001:2015 and WHO-GMP compliance."
//     }
//   ];

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setCurrentSlide((prev) => (prev + 1) % slides.length);
//     }, 5000);
//     return () => clearInterval(timer);
//   }, []);

//   const scrollToSection = (id: string) => {
//     const element = document.getElementById(id);
//     if (element) {
//       element.scrollIntoView({ behavior: 'smooth' });
//     }
//   };

//   const goToSlide = (index: number) => {
//     setCurrentSlide(index);
//   };

//   const nextSlide = () => {
//     setCurrentSlide((prev) => (prev + 1) % slides.length);
//   };

//   const prevSlide = () => {
//     setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
//   };

//   return (
//     <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
//   {/* Carousel Images */}
//   <div className="absolute inset-0">
//     {slides.map((slide, index) => (
//       <div
//         key={index}
//         className={`absolute inset-0 transition-opacity duration-1000 ${
//           index === currentSlide ? 'opacity-100' : 'opacity-0'
//         }`}
//       >
//         <img
//           src={slide.image}
//           alt={slide.title}
//           className="w-full h-full object-cover object-center"
//         />
//         {/* Lighter blue overlay */}
//         <div className="absolute inset-0 bg-gradient-to-r from-blue-500/30 via-blue-400/25 to-blue-500/30"></div>
//       </div>
//     ))}
//   </div>

//   {/* Navigation Arrows */}
//   <button
//     onClick={prevSlide}
//     className="absolute left-6 top-1/2 -translate-y-1/2 z-20 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white w-12 h-12 rounded-full flex items-center justify-center transition-all cursor-pointer"
//     aria-label="Previous slide"
//   >
//     <i className="ri-arrow-left-s-line text-2xl"></i>
//   </button>
//   <button
//     onClick={nextSlide}
//     className="absolute right-6 top-1/2 -translate-y-1/2 z-20 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white w-12 h-12 rounded-full flex items-center justify-center transition-all cursor-pointer"
//     aria-label="Next slide"
//   >
//     <i className="ri-arrow-right-s-line text-2xl"></i>
//   </button>

//   {/* Content */}
//      <div className="relative z-10 mt-12 max-w-7xl mx-auto px-6 py-32">
//          <div className="max-w-3xl">
//           <h1 className="text-6xl md:text-7xl font-bold [text-shadow:2px_2px_4px_rgba(0,0,0,0.5)] text-white leading-tight mb-6 transition-all duration-500">
//             {slides[currentSlide].title}
//           </h1>
//           <p className="text-xl text-white [text-shadow:2px_2px_4px_rgba(0,0,0,0.5)] mb-10 leading-relaxed transition-all duration-500">
//             {slides[currentSlide].description}
//           </p>
//           <div className="flex flex-wrap gap-4 mb-12">
//             <button
//               onClick={() => scrollToSection('products')}
//               className="bg-blue-600  text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-blue-700 transition-all hover:shadow-lg whitespace-nowrap cursor-pointer"
//             >
//               Explore Products
//               <i className="ri-arrow-right-line ml-2"></i>
//             </button>
//             <button
//               onClick={() => scrollToSection('about')}
//               className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-white hover:text-blue-900 transition-all whitespace-nowrap cursor-pointer"
//             >
//               Learn More
//             </button>
//           </div>
//           <div className="flex items-center gap-6 text-white [text-shadow:2px_2px_4px_rgba(0,0,0,0.3)] text-sm">
//             <div className="flex items-center gap-2">
//               <i className="ri-shield-check-line text-2xl text-blue-500"></i>
//               <span>ISO 9001:2015 Certified</span>
//             </div>
//             <div className="flex items-center gap-2">
//               <i className="ri-hospital-line text-2xl text-blue-500 [text-shadow:2px_2px_4px_rgba(0,0,0,0.2)]"></i>
//               <span>WHO-GMP Compliant</span>
//             </div>
//           </div>
//         </div>
//       </div>

//   {/* Carousel Indicators */}
//   <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex gap-3">
//     {slides.map((_, index) => (
//       <button
//         key={index}
//         onClick={() => goToSlide(index)}
//         className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
//           index === currentSlide
//             ? 'bg-blue-200 w-8'
//             : 'bg-blue-200/50 hover:bg-blue-200/70'
//         }`}
//         aria-label={`Go to slide ${index + 1}`}
//       />
//     ))}
//   </div>
// </section>
//   );
// }

import { useState, useEffect } from 'react';

export default function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: "/assets/Hero3.jpg",
      title: "Trusted Cardiovascular Solutions for <br/>Healthier Hearts",
      description: "Pioneering excellence in cardiac and diabetic health care with innovative pharmaceutical solutions."
    },
    {
      image: "/assets/Hero2.jpg",
      title: "Comprehensive Diabetic Care Solutions",
      description: "Providing premium quality diabetic care <br/>medicines and cardiovascular products."
    },
    {
      image: "/assets/Hero1.jpg",
      title: "Quality Medicines <br/>for Better Health",
      description: "Sourcing and distributing premium pharmaceutical products for cardiac, diabetic, and chronic disease management."
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 10000);
    return () => clearInterval(timer);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Carousel Images */}
      <div className="absolute inset-0">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${index === currentSlide ? 'opacity-100' : 'opacity-0'
              }`}
          >
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover object-center"
            />
            {/* Gradient overlay - lighter on left side where text appears */}
            <div className="absolute inset-0 bg-gradient-to-r from-blue-500/30 via-blue-400/25 to-blue-500/30"></div>
            {/* Additional dark overlay on right side to balance */}
            <div className="absolute inset-0 bg-gradient-to-l from-black/30 via-transparent to-transparent"></div>
          </div>
        ))}
      </div>

      {/* Navigation Arrows */}
      <button
        onClick={prevSlide}
        className="absolute left-6 top-1/2 -translate-y-1/2 z-20 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white w-12 h-12 rounded-full flex items-center justify-center transition-all cursor-pointer"
        aria-label="Previous slide"
      >
        <i className="ri-arrow-left-s-line text-2xl"></i>
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-6 top-1/2 -translate-y-1/2 z-20 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white w-12 h-12 rounded-full flex items-center justify-center transition-all cursor-pointer"
        aria-label="Next slide"
      >
        <i className="ri-arrow-right-s-line text-2xl"></i>
      </button>

      {/* Content - Adjusted to left side with responsive width */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="max-w-xl lg:max-w-2xl">
          <h1
            className="text-4xl md:text-5xl lg:text-6xl font-bold [text-shadow:2px_2px_4px_rgba(0,0,0,0.3)] text-white leading-tight mb-6 transition-all duration-500"
            dangerouslySetInnerHTML={{ __html: slides[currentSlide].title }}
          />
          <p className="text-lg md:text-xl text-white mb-8 leading-relaxed [text-shadow:2px_2px_4px_rgba(0,0,0,1)] text-shadow:-2px_-2px_-4px_rgba(255,255,255,0.9)]  transition-all duration-500"
            dangerouslySetInnerHTML={{ __html: slides[currentSlide].description }}/>
          <div className="flex flex-wrap gap-4 mb-12">
            <button
              onClick={() => scrollToSection('products')}
              className="bg-blue-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-blue-700 transition-all hover:shadow-lg whitespace-nowrap cursor-pointer"
            >
              Explore Products
              <i className="ri-arrow-right-line ml-2"></i>
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-white hover:text-blue-900 transition-all whitespace-nowrap cursor-pointer"
            >
              Learn More
            </button>
          </div>
          <div className="flex flex-wrap items-center gap-6 text-white text-sm">
            <div className="flex items-center gap-2 bg-black/30 px-4 py-2 rounded-lg backdrop-blur-sm">
              <i className="ri-shield-check-line text-2xl text-blue-300"></i>
              <span>ISO 9001:2015 Certified</span>
            </div>
            <div className="flex items-center gap-2 bg-black/30 px-4 py-2 rounded-lg backdrop-blur-sm">
              <i className="ri-hospital-line text-2xl text-blue-300"></i>
              <span>WHO-GMP Compliant</span>
            </div>
          </div>
        </div>
      </div>

      {/* Carousel Indicators - Moved to bottom right */}
      <div className="absolute bottom-8 right-8 z-20 flex gap-3">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-3 h-3 rounded-full transition-all cursor-pointer ${index === currentSlide
                ? 'bg-white w-8'
                : 'bg-white/50 hover:bg-white/70'
              }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
}